import styled from '@emotion/styled';

export const Container = styled.div`
  max-width: 1200px;
  margin: auto;
  
  .lead {
    font-size: 18px;
  }
  .ant-collapse-content {
    background-color: white !important;
  }
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
`;